import { LegacyContentWrapper } from "@Components/game";
import { BybList, BybListSubheader, ListItemCell, ListItemLayout } from "@Components/game/common";
import ContainerWrapper from "@Components/generic/container-wrapper";
import Icon from "@Components/generic/icon";
import SessionResultSmall from "@Containers/shared/cards/session-result-small";
import TitleWrapper from "@Containers/shared/title-wrapper";
import { Actions, AppContext, Events } from "@Context/common/general/context";
import { faBrain } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { capitalize, Container, List, Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { forEach, groupBy } from "lodash-es";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PageId = "CHALLENGE_SESSIONS";

const ChallengeSessions = () => {
  const { dispatch, state } = useContext(AppContext);
  const { i18n } = useI18n();
  const theme = useTheme();
  const navData: any = useLocation().state || {};
  const [data, setData] = useState<any>(navData);
  const { play_session_ids } = data;
  const [userSessions, setUserSessions] = useState<any[]>();

  useEffect(() => {
    dispatch({
      type: Actions.StatsActions.GetUserSessions,
      payload: {
        user_id: state.user.id,
        limit: 200,
        is_completed: true,
        play_session_ids: play_session_ids,
      },
      cacheTime: [5, "minutes"],
      onSuccess: (response) => {
        // Create a new array with all the results grouped by month
        let groupedResults = groupBy(response, (item) => dayjs(item.updated_at).format("MMMM YYYY"));

        let results: any[] = [];
        let best = 0;

        forEach(groupedResults, (value, key) => {
          results.push({
            items: value.map((item: any, index: number) => {
              return {
                ...item,
                previous_score: value[index + 1] ? value[index + 1].byb_iq : 0, // todo: get previous score from session data when available
                best: item.byb_iq > best && response.length > 1,
              };
            }),
            month: key,
          });
        });

        setUserSessions(results);
      },
    });
  }, []);

  return (
    <ContainerWrapper id={PageId} enableBackButton sx={{ overflow: "visible" }}>
      <Container maxWidth={false}>
        <LegacyContentWrapper>
          <TitleWrapper title={i18n("sessions.label")}>
            <BybList sx={{ maxHeight: `calc(100vh - ${state.app.navBarHeight + 78}px)` }}>
              {userSessions?.map((item, i) => (
                <li key={`section-${item.month}`}>
                  <List
                    sx={{ paddingTop: 0 }}
                    subheader={
                      <BybListSubheader>
                        <ListItemLayout>
                          <ListItemCell first subHeader colSpan={3}>
                            <Typography variant="textBase600">{capitalize(item.month)}</Typography>
                          </ListItemCell>
                          <ListItemCell>
                            <Typography variant="textBase600">{i18n("rating-points.label")}</Typography>
                          </ListItemCell>
                          <ListItemCell>
                            <Typography variant="textBase600">{i18n("comparison.label")}</Typography>
                          </ListItemCell>
                          <ListItemCell>
                            <Stack
                              direction="row"
                              spacing={1}
                              sx={{
                                alignItems: "center",
                              }}
                            >
                              <Icon
                                icon={faBrain}
                                sx={{
                                  color: theme.palette.dsSurface.v300,
                                  fontSize: theme.spacing(1.75),
                                }}
                              />
                              <Typography variant="textBase600">{i18n("bybiq.label")}</Typography>
                            </Stack>
                          </ListItemCell>
                        </ListItemLayout>
                      </BybListSubheader>
                    }
                  >
                    {item.items.map((item: any, index: number) => (
                      <SessionResultSmall
                        key={`item-${item.month}-${index}`}
                        sessionType={item.session_type}
                        gameMode={item.game_mode}
                        focuses={["ALL"]}
                        score={item.byb_iq || 0}
                        previousScore={item.previous_score || 0}
                        updatedAt={item.updated_at}
                        gameplayDuration={item.total_gameplay_duration}
                        onClick={() => {
                          Events.app.navigate.emit({
                            path: `${location.pathname}/session/${item.play_session_id}`,
                            delay: 150,
                          });
                        }}
                        rating={item.experience_gained || 0}
                      />
                    ))}
                  </List>
                </li>
              ))}
            </BybList>
          </TitleWrapper>
        </LegacyContentWrapper>
      </Container>
    </ContainerWrapper>
  );
};

export default ChallengeSessions;
